<template lang="html">
    <footer class="footer">
        <div class="container">
            <el-row type="flex" justify="space-between">
                <el-col :span="6">
                    <div class="edf-footer-logo">
                        <img src="/static/img/edf-w.svg" alt="">
                    </div>
                </el-col>
                <el-col :span="6" class="viveco">
                    <h1 class="h1">VIVECO</h1>
                    <p class="small">{{getText('viveco_description')}}</p>
                </el-col>
                <el-row type="flex" justify="space-between">
                    <el-col>
                        <div class="footer-links-wrapper">
                            <div class="footer-links">
                                <router-link :to="{ name: 'mentions' }">
                                    <el-button class="mentions">{{getText('mentions_link')}}</el-button>
                                </router-link>
                            </div>
                            <p class="small" :title="version">Viveco v1 - {{getText('copyright')}}</p>
                        </div>
                    </el-col>
                </el-row>
            </el-row>
        </div>
    </footer>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    data (){
        return {
        };
    },

    computed: {
        ...mapGetters([
            'getText'
        ]),
        version (){
            try{
                return VERSION;
            }catch(e){
                console.debug(e);
                return '';
            }
        }
    }
};
</script>

<style lang="less">
@import '../../less/variables';
.footer {
    background: @color-text;
    color: white;
    padding: 20px;
    .viveco {
        margin-left: 10%;
        .h1 {
            display: block;
            width: 100%;
            color: white;
            margin-bottom: 0px;
            margin-top: 20px;
            font-size: 20px;
        }
    }
    .footer-links-wrapper {
        text-align: right;
        display: block;
        width: 100%;
        .small {
            padding-right: 16px;
        }
        .footer-links {
            display: flex;
            justify-content: flex-end;
            flex-wrap: wrap;
            align-items: flex-end;
            padding-bottom: 10px;
            .mentions {
                margin-top: 10px;
            }
            a {
                &:first-child {
                    margin-right: 30px;
                }
                display: inline-block;
                text-align: left;
                button {
                    color: white;
                    text-transform: uppercase;
                    background-color: transparent;
                    border: none;
                    font-family: worksans, Arial, "Helvetica Neue", Helvetica, sans-serif;
                }
            }
            a:last-child {
                button {
                    margin-right: 0;
                }
                align-self: flex-end;
                float: right;
            }
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/components/ui/page-footer.vue